const defaultState = {
  windowLevelData: {
    1: { description: 'Soft tissue', window: '550', level: '40' },
    2: { description: 'Lung', window: '1500', level: '-600' },
    3: { description: 'Liver', window: '150', level: '90' },
    4: { description: 'Bone', window: '2500', level: '480' },
    5: { description: 'Brain', window: '80', level: '40' },
    6: { description: 'Chest and ABD/Pelvis', window: '350', level: '40' },
    7: { description: 'Head/Neck', window: '350', level: '90' },
    8: { description: 'Brain T1', window: '500', level: '250' },
    9: { description: 'Brain T2', window: '350', level: '150' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
